import { TextField, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import * as React from "react";
import { styles } from "./FormTextField.styles";


export interface IFormTextFieldProps extends WithStyles<typeof styles> {
    label: string
    className?: string,
    type?: string
    onChange?: any,
    id?: string,
    value?: any,
    error?: boolean,
    helperText?: string,
    required?: boolean,
    pattern?: RegExp,
    disabled?: boolean,
    multiline?: any,
    rows?: any
}

const FormTextFieldPure: React.FunctionComponent<IFormTextFieldProps> = ({
                                                                             label,
                                                                             className,
                                                                             type,
                                                                             onChange,
                                                                             id,
                                                                             value,
                                                                             error,
                                                                             helperText,
                                                                             required,
                                                                             pattern,
                                                                             disabled,
                                                                             multiline,
                                                                             rows,
                                                                             classes
                                                                         }: IFormTextFieldProps) => {

    const [state, setState] = React.useState({
        tempHelperText: helperText,
        tempError: error,
    });

    React.useEffect(() => {
        setState({
            ...state,
            tempHelperText: helperText,
            tempError: error
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const tempOnChange = event => {
        const value = event.target.value;

        let valid = true;
        if (required && !value) {
            setState({
                ...state,
                tempHelperText: label + " is required.",
                tempError: true
            });
            valid = false;
        } else if (required && value === "") {
            setState({
                ...state,
                tempHelperText: label + " cannot be empty.",
                tempError: true
            });
            valid = false;
        } else if (pattern && !value.match(pattern) && value !== "") {
            setState({
                ...state,
                tempHelperText: "Please enter a valid format.",
                tempError: true
            });
            valid = false;
        } else {
            setState({
                ...state,
                tempHelperText: helperText,
                tempError: error
            });
        }
        onChange(event, valid);
    };

    return <div className={className}>
        <TextField
            className={multiline ? classes.multilineField : classes.inputField}
            error={state.tempError}
            required={required}
            helperText={state.tempHelperText}
            fullWidth={true}
            variant="filled"
            label={label}
            type={type}
            onChange={tempOnChange}
            disabled={disabled}
            InputLabelProps={
                type === "date"
                    ? {shrink: true}
                    : {}
            }
            id={id}
            name={id}
            value={value}
            key={id}
            multiline={multiline}
            rows={rows}
        />
    </div>;
};

export const FormTextField = withStyles(styles)(FormTextFieldPure);